import { show } from "redux-modal";
import * as Yup from "yup";

export const dataModel = {
  sapDateStartInit: "",
  sapDateEnd: "",
  status: "",
  idOrderSap: "",
  sapQuantity: "",
  showNotificated: false,
};

export const validationDataModel = Yup.object().shape({
  sapDateStartInit: Yup.date().optional(),
  sapDateEnd: Yup.date().optional(),
  status: Yup.string().optional(),
  idOrderSap: Yup.string().optional(),
  sapQuantity: Yup.string().optional(),
  showNotificated: Yup.boolean().optional(),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });

    if (initialValues.sapDateStartInit) {
      newValues.sapDateStartInit = new Date(initialValues.sapDateStartInit);
    }
    if (initialValues.sapDateEnd) {
      newValues.sapDateEnd = new Date(initialValues.sapDateEnd);
    }
    return newValues;
  }

  return dataModel;
};
